module.exports = __webpack_public_path__ + "img/5c.dd894855.png";